import React, { useState, useEffect } from "react";
import { http } from "../../lib/http";
import { getUser } from "../../lib/authToken";

export default function PauseToggle() {
  const [isActive, setIsActive] = useState(false); // ❗ no default active
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const user = getUser();
  const accountId = user?.restaurant_id;

  // 🔹 FETCH STATUS ON LOGIN (GET ONLY)
  useEffect(() => {
    if (!accountId) {
      setError("User not authenticated");
      setLoading(false);
      return;
    }

    const fetchStatus = async () => {
      try {
        const response = await http.get(`fe/${accountId}/status`);
        setIsActive(Boolean(response.rest_status)); // 0 or 1 → boolean
        setError(null);
      } catch (err) {
        setError("Failed to fetch status");
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [accountId]);

  // 🔹 UPDATE STATUS ONLY WHEN TOGGLE IS CLICKED
  const togglePaused = async () => {
    if (!accountId) return;

    const newStatus = !isActive;

    try {
      await http.put(`fe/${accountId}/status`, {
        rest_status: newStatus ? 1 : 0,
      });

      setIsActive(newStatus);
      setError(null);
    } catch (err) {
      setError("Failed to update status");
    }
  };

  return (
    <div className="pause-toggle">
      {loading && <div>Loading...</div>}

      {!loading && (
        <label className="pause-label">
          <input
            type="checkbox"
            checked={isActive}
            onChange={togglePaused}
            disabled={!accountId}
            className="pause-checkbox"
          />
          <span className="pause-slider"></span>
          <span className="pause-text">{isActive ? "Active" : "Paused"}</span>
        </label>
      )}

      {error && <div className="error-message">{error}</div>}
    </div>
  );
}
